
import { mapGetters } from 'vuex'

export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters('global', ['shopNavigation']),

    heading() {
      return this.breadcrumbs[this.breadcrumbs.length - 2].title
    },

    current() {
      return this.$route.path
    },

    isFirstLevel() {
      return this.breadcrumbs.length === 2
    },

    isSecondLevel() {
      return this.breadcrumbs.length === 3
    },

    isThirdLevel() {
      return this.breadcrumbs.length === 4
    },

    links() {
      if (this.isFirstLevel) {
        return this.shopNavigation
          .find((nav) => nav.page.url === this.breadcrumbs[1].url)
          .children.map((nav) => nav.page)
      }

      return this.shopNavigation
        .find((nav) => nav.page.url === this.breadcrumbs[1].url)
        .children.find((nav) => nav.page.url === this.breadcrumbs[2].url)
        .children.map((nav) => nav.page)
    },
  },
}
